import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import store from '../../../app/store';
import RowClick from '../../../common/RowClick';
import Table from '../../../common/table/Table';
import { NEW_LISTING, OTHER_LISTING } from '../Const';
import { loadMoreListing } from '../reducer';
import Const from './Const';
import {
  formatTextFloat,
  formatPrice,
  formatValueBillion,
  formatPercent,
} from '../../../helpers/Text';
import { formatDate } from '../../../helpers/DateTime';
import { getColorSourceLink } from '../../../helpers/Color';
import { getDataFollowKeyByDot } from './../../../helpers/Common';
import PerformanceChartWrap from '../../watchlist/summary/PerformanceChartWrap';
import {
  REDUCER_NAME,
  loadMoreCorporateDiv,
  fetchListDataTable,
} from './../reducer';
import _ from 'lodash';
import { compose } from 'redux';
import TradingViewUrl from '../../../common/TradingViewUrl';

const TYPES = {
  CASH: 'cashDividend',
  STOCK: 'stockDividend',
  NEW_LISTING: 'newListing',
  OTHER_LISTING: 'otherListing',
};

const valText = '--';

class TableAnomaly extends React.Component {
  constructor(props) {
    super(props);
    this.initialState = {
      isCashDiv: this.props.typeDiv === TYPES.CASH,
      page: this.props.currentPage,
      pageSize: 50,
      currentFilterEvents: props.currentFilterEvents,
    };
    this.state = this.initialState;
    this.tableRef = React.createRef();
  }

  resetScroll = () => {
    this.tableRef.current.scrollToTop();
  };

  componentWillReceiveProps(nextProps) {
    const { currentFilterEvents } = this.state;
    if (nextProps.currentFilterEvents !== currentFilterEvents) {
      this.setState({
        ...this.state,
        page: 1,
        currentFilterEvents: nextProps.currentFilterEvents,
      });
    }
  }

  componentDidUpdate(prewProps, prevState) {
    if (prewProps.currentFilterEvents !== this.props.currentFilterEvents) {
      this.resetScroll();
    }
    if (prewProps.i18n && prewProps.i18n.locale !== this.props.i18n.locale) {
      const { fetchListDataTable } = this.props;
      fetchListDataTable();
    }
  }

  getDataFromRedux = () => {
    const { typeDiv: type } = this.props;
    if (type === TYPES.CASH) {
      return state => state[REDUCER_NAME].listCashDividendByTicker;
    }
    if (type === TYPES.STOCK) {
      return state => state[REDUCER_NAME].listStockDividendByTicker;
    }

    if (type === TYPES.NEW_LISTING) {
      return state => state[REDUCER_NAME].newListingData;
    }

    if (type === TYPES.OTHER_LISTING) {
      return state => state[REDUCER_NAME].otherListingData;
    }

    return state => state[REDUCER_NAME].listDataByTicker;
  };

  getIds = () => {
    const {
      ids,
      cashDividendIds,
      stockDividendIds,
      newListingIds,
      otherListingIds,
      typeDiv: type,
    } = this.props;

    if (type === TYPES.CASH) {
      return cashDividendIds;
    }

    if (type === TYPES.STOCK) {
      return stockDividendIds;
    }

    if (type === TYPES.NEW_LISTING) {
      return newListingIds;
    }

    if (type === TYPES.OTHER_LISTING) {
      return otherListingIds;
    }

    return ids;
  };

  loadMoreNewListing = () => {
    const { page, pageSize } = this.state;
    const { totalPageNewListing, loadMoreListing } = this.props;
    if (page >= totalPageNewListing) {
      return;
    }
    const nextPage = page + 1;
    this.setState({
      page: nextPage,
    });
    loadMoreListing({
      Page: nextPage,
      PageSize: pageSize,
      ListingTbl: NEW_LISTING,
    });
  };

  loadMoreOtherListing = () => {
    const { page, pageSize } = this.state;
    const { totalPageOtherListing, loadMoreListing } = this.props;
    if (page >= totalPageOtherListing) {
      return;
    }
    const nextPage = page + 1;
    this.setState({
      page: nextPage,
    });
    loadMoreListing({
      Page: 1,
      PageSize: pageSize,
      ListingTbl: OTHER_LISTING,
    });
  };

  handleScroll = e => {
    const { isCashDiv } = this.state;
    const {
      totalPageCash,
      totalPageStock,
      currenPageScrollCash,
      currenPageScrollStock,
      currentFilterEvents,
      totalPageCoporateTypeEvent,
      currenPageScrollCoporateTypeEvent,
      typeDiv: type,
    } = this.props;
    const bottom =
      e.target.scrollHeight - Math.ceil(e.target.scrollTop) ===
      e.target.clientHeight;
    if (!bottom) {
      return;
    }

    if (type === TYPES.NEW_LISTING) {
      this.loadMoreNewListing();
      return;
    }

    if (type === TYPES.OTHER_LISTING) {
      this.loadMoreOtherListing();
      return;
    }

    let response = 0;
    let currenPageScroll = 1;
    if (currentFilterEvents === Const.listFilterEventByKey.div.key) {
      if (isCashDiv) {
        response = totalPageCash;
        currenPageScroll = currenPageScrollCash;
      } else {
        response = totalPageStock;
        currenPageScroll = currenPageScrollStock;
      }
    } else {
      response = totalPageCoporateTypeEvent;
      currenPageScroll = currenPageScrollCoporateTypeEvent;
    }

    if (currenPageScroll < response) {
      if (bottom) {
        this.loadmoreActive(response, currentFilterEvents);
      }
    }
  };

  loadmoreActive = (totalPage, currentFilterEvents) => {
    const { isCashDiv } = this.state;
    const { loadMoreCorporateDiv } = this.props;

    this.setState(
      prevState => {
        return {
          page:
            prevState.page === totalPage
              ? prevState.page
              : (prevState.page += 1),
        };
      },
      () => {
        const { page, pageSize } = this.state;
        loadMoreCorporateDiv(
          { Page: page, PageSize: pageSize, isCashDiv },
          currentFilterEvents,
        );
      },
    );
  };

  onRowClick = (id, handler) => {
    const state = store.getState();
    const data = this.getDataFromRedux()(state);
    if (!data[id]) {
      return;
    }
    handler(data[id].organCode);
  };

  render() {
    const { isCashDiv } = this.state;
    const {
      currentFilterEvents,
      typeDiv,
      isFetchingCorporate,
      isFetchingCorporateStock,
      isFetchingTypeCorporate,
    } = this.props;
    let marketCarlendarTable = Const.marketCarlendarErnTable;
    let titleTable = `marketCalendarCorporate.marketCarlendarErnTable`;

    switch (currentFilterEvents) {
      case Const.listFilterEventByKey.div.key:
        if (typeDiv === Const.listTypeDivEventByKey.cash.key) {
          marketCarlendarTable = Const.marketCarlendarDivCashTable;
          titleTable = `marketCalendarCorporate.marketCarlendarDivCashTable`;
        } else {
          marketCarlendarTable = Const.marketCarlendarDivStockTable;
          titleTable = `marketCalendarCorporate.marketCarlendarDivStockTable`;
        }
        break;
      case Const.listFilterEventByKey.sis.key:
        marketCarlendarTable = Const.marketCarlendarSisTable;
        titleTable = `marketCalendarCorporate.marketCarlendarSisTable`;
        break;
      case Const.listFilterEventByKey.ipo.key:
        marketCarlendarTable = Const.marketCarlendarLisTable;
        titleTable = `marketCalendarCorporate.marketCarlendarLisTable`;
        break;
      case Const.listFilterEventByKey.agm.key:
        marketCarlendarTable = Const.marketCarlendarAgmTable;
        titleTable = `marketCalendarCorporate.marketCarlendarAgmTable`;
        break;
      default:
        break;
    }

    let isFetching;
    if (currentFilterEvents === Const.listFilterEventByKey.div.key) {
      if (isCashDiv) {
        isFetching = isFetchingCorporate;
      } else {
        isFetching = isFetchingCorporateStock;
      }
    } else {
      isFetching = isFetchingTypeCorporate;
    }

    return (
      <RowClick>
        {onRowClick => (
          <Table
            scrollRef={this.tableRef}
            thValign="top"
            ids={this.getIds()}
            getDataFromRedux={this.getDataFromRedux()}
            onScrollFunction={this.handleScroll}
            isLoading={isFetching}
            clickRow={id => this.onRowClick(id, onRowClick)}
            schema={Object.keys(marketCarlendarTable).map((item, index) => {
              const key = marketCarlendarTable[item];
              const title = `${titleTable}.${item}`;
              const result = {
                key,
                title,
              };

              if (
                index === 0 &&
                marketCarlendarTable === Const.marketCarlendarErnTable
              ) {
                return {
                  disableSort: true,
                  ...result,
                  render: (text, item) => (
                    <>
                      <TradingViewUrl code={item.organCode} />
                      &nbsp;{text}
                    </>
                  ),
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarAgmTable.TICKER,
                    Const.marketCarlendarLisTable.TICKER,
                    Const.marketCarlendarSisTable.TICKER,
                    Const.marketCarlendarDivStockTable.TICKER,
                    Const.marketCarlendarDivCashTable.TICKER,
                  ],
                  key,
                )
              ) {
                return {
                  ...result,
                  isString: true,
                  render: (text, item) => {
                    return (
                      <>
                        <TradingViewUrl code={item.organCode} />
                        &nbsp;{text}
                      </>
                    );
                  },
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarErnTable.REVENUE,
                    Const.marketCarlendarErnTable.PROFIT,
                  ],
                  key,
                ) &&
                marketCarlendarTable === Const.marketCarlendarErnTable
              ) {
                return {
                  disableSort: true,
                  ...result,
                  thTooltip: I18n.t('marketCalendarCorporate.lastestQuarter'),
                  render: text => {
                    return formatTextFloat(formatValueBillion(text));
                  },
                };
              }

              if (
                key === Const.marketCarlendarErnTable.INTERIM &&
                marketCarlendarTable === Const.marketCarlendarErnTable
              ) {
                return {
                  disableSort: true,
                  ...result,
                  render: (_, item) => {
                    if (item.lengthReport !== 5) {
                      return `Q${item.lengthReport}/${item.yearReport}`;
                    }

                    return item.yearReport;
                  },
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarErnTable.REV,
                    Const.marketCarlendarErnTable.PROFIT_FORECAT,
                  ],
                  key,
                ) &&
                marketCarlendarTable === Const.marketCarlendarErnTable
              ) {
                return {
                  disableSort: true,
                  ...result,
                  thTooltip: I18n.t(
                    'marketCalendarCorporate.forecastForCurrentYear',
                  ),
                  render: (text, item) => {
                    return formatTextFloat(formatValueBillion(text));
                  },
                };
              }

              if (
                _.includes(
                  [
                    // Const.marketCarlendarErnTable.COMPANY,
                    Const.marketCarlendarDivCashTable.DIV_YEAR,
                    Const.marketCarlendarDivStockTable.DIV_YEAR,
                    Const.marketCarlendarSisTable.YEAR,
                  ],
                  key,
                )
              ) {
                return {
                  ...result,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return <div className="text-left"> {text} </div>;
                  },
                };
              }

              //==============================
              //DIV section
              //==============================
              if (
                _.includes(
                  [
                    Const.marketCarlendarDivCashTable.DIV_TYPE,
                    Const.marketCarlendarDivStockTable.DIV_TYPE,
                  ],
                  key,
                )
              ) {
                return {
                  disableSort: true,
                  ...result,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return <div className="text-left"> {text} </div>;
                  },
                };
              }

              if (
                _.includes([Const.marketCarlendarSisTable.ISSUE_VOLUMN], key)
              ) {
                return {
                  ...result,
                  render: (text, item) => {
                    return formatTextFloat(formatPrice(text));
                  },
                };
              }

              // if (
              //   _.includes(
              //     [
              //       Const.marketCarlendarDivCashTable.VALUE,
              //     ],
              //     key,
              //   )
              // ) {
              //   return {
              //     ...result,
              //     render: (text, item) => {
              //       return text;
              //     },
              //   };
              // }

              if (
                _.includes(
                  [
                    Const.marketCarlendarDivCashTable.RECORD_DATE,
                    Const.marketCarlendarDivCashTable.PAYOUT_DATE,
                    Const.marketCarlendarDivStockTable.RECORD_DATE,
                    Const.marketCarlendarDivStockTable.PAYOUT_DATE,
                    Const.marketCarlendarDivCashTable.AN_DATE,
                    Const.marketCarlendarDivCashTable.EX_RIGHT_DATE,
                    Const.marketCarlendarDivStockTable.AN_DATE,
                    Const.marketCarlendarDivStockTable.EX_RIGHT_DATE,
                    Const.marketCarlendarSisTable.ISSUE_DATE,
                    Const.marketCarlendarSisTable.LISTING_DATE,
                    Const.marketCarlendarLisTable.AN_DATE,
                    Const.marketCarlendarLisTable.RECORD_DATE,
                    Const.marketCarlendarLisTable.EX_RIGHT_DATE,
                    Const.marketCarlendarLisTable.EXERCISE_DATE,
                  ],
                  key,
                )
              ) {
                return {
                  ...result,
                  isString: true,
                  thStyle: { textAlign: 'left' },
                  valueFromItem: item => {
                    const date = getDataFollowKeyByDot(item, key);
                    return date === '--' ? '' : date;
                  },
                  render: (text, item) => {
                    let date = new Date(text);
                    return text !== valText ? (
                      <div className="text-left">{formatDate(date)}</div>
                    ) : (
                      <div className="text-left" />
                    );
                  },
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarDivStockTable.EX_RATIO,
                    Const.marketCarlendarDivCashTable.EX_RATIO,
                    Const.marketCarlendarSisTable.ISSUE_PERCEN,
                  ],
                  key,
                )
              ) {
                return {
                  ...result,
                  render: text => {
                    return formatTextFloat(formatPercent(text)) + '%';
                  },
                };
              }

              if (
                _.includes([Const.marketCarlendarDivCashTable.REFERENCE], key)
              ) {
                return {
                  ...result,
                  disableSort: true,
                  render: text => text,
                };
              }

              //==============================
              //SIS section
              //==============================
              if (_.includes([Const.marketCarlendarSisTable.STATUS], key)) {
                return {
                  ...result,
                  disableSort: true,
                  thStyle: { textAlign: 'left' },
                  render: text => text,
                };
              }

              if (
                _.includes([Const.marketCarlendarSisTable.ISSUE_VOLUMN], key)
              ) {
                return {
                  ...result,
                  render: text => {
                    return formatPrice(text);
                  },
                };
              }

              if (
                _.includes([Const.marketCarlendarSisTable.ISSUE_METHOD], key)
              ) {
                return {
                  ...result,
                  isString: true,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return <div className="text-left">{text}</div>;
                  },
                };
              }

              //==============================
              //LIS section
              //==============================
              if (
                _.includes([Const.marketCarlendarLisTable.LISTING_TYPE], key)
              ) {
                return {
                  ...result,
                  thStyle: { textAlign: 'right' },
                  render: text => {
                    return <div className="text-right"> {text} </div>;
                  },
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarIpoTable.COMPANY,
                    Const.marketCarlendarErnTable.COMPANY,
                    Const.marketCarlendarAgmTable.COMPANY,
                  ],
                  key,
                )
              ) {
                return {
                  disableSort: true,
                  ...result,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return <div className="text-left"> {text} </div>;
                  },
                };
              }

              //==============================
              //AGM section
              //==============================

              if (
                _.includes(
                  [
                    Const.marketCarlendarAgmTable.LOCATION,
                    Const.marketCarlendarAgmTable.VENUE,
                  ],
                  key,
                )
              ) {
                return {
                  ...result,
                  isString: true,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return text !== valText ? (
                      <div className="text-left">{text}</div>
                    ) : (
                      <div />
                    );
                  },
                };
              }

              if (_.includes([Const.marketCarlendarAgmTable.SOURCE], key)) {
                return {
                  disableSort: true,
                  ...result,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return text !== valText ? (
                      <div className={getColorSourceLink('text')}>{text}</div>
                    ) : (
                      <div className={getColorSourceLink('text')} />
                    );
                  },
                };
              }

              if (_.includes([Const.marketCarlendarAgmTable.VENUE], key)) {
                return {
                  disableSort: true,
                  ...result,
                  thStyle: { textAlign: 'left' },
                  render: text => {
                    return <div className="text-left"> {text} </div>;
                  },
                };
              }

              if (
                _.includes(
                  [
                    Const.marketCarlendarErnTable.PERFORMANCE,
                    Const.marketCarlendarDivCashTable.PERFORMANCE,
                    Const.marketCarlendarDivStockTable.PERFORMANCE,
                    Const.marketCarlendarLisTable.PERFORMANCE,
                  ],
                  key,
                )
              ) {
                return {
                  disableSort: true,
                  disableResize: true,
                  tdClassName: 'fix-width-chart',
                  thStyle: { textAlign: 'center', width: '120px' },
                  ...result,
                  render: (text, item) => {
                    let organCode = getDataFollowKeyByDot(
                      item,
                      Const.index.ORGAN_CODE,
                    );
                    return (
                      <div style={{ margin: '0 auto' }}>
                        <PerformanceChartWrap
                          key={item.ticker}
                          ticker={organCode}
                        />
                      </div>
                    );
                  },
                };
              }

              return {
                ...result,
                render: text => text,
              };
            })}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = (state, { typeDiv }) => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listTickerTable,
    cashDividendIds: state[REDUCER_NAME].listCashDividend,
    stockDividendIds: state[REDUCER_NAME].listStockDividend,
    currentFilterEvents: state[REDUCER_NAME].currentFilterEvents,
    typeDiv: typeDiv,

    totalPageCash: state[REDUCER_NAME].totalPageCash,
    totalPageStock: state[REDUCER_NAME].totalPageStock,

    isFetchingCorporate: state[REDUCER_NAME].isFetchingCorporate,
    isFetchingCorporateStock: state[REDUCER_NAME].isFetchingCorporateStock,

    currenPageScrollCash: state[REDUCER_NAME].currenPageScrollCash,
    currenPageScrollStock: state[REDUCER_NAME].currenPageScrollStock,
    currentPage: state[REDUCER_NAME].currentPage,

    totalPageCoporateTypeEvent: state[REDUCER_NAME].totalPageCoporateTypeEvent,
    currenPageScrollCoporateTypeEvent:
      state[REDUCER_NAME].currenPageScrollCoporateTypeEvent,
    isFetchingTypeCorporate: state[REDUCER_NAME].isFetchingTypeCorporate,

    newListingIds: state[REDUCER_NAME].newListingIds,
    otherListingIds: state[REDUCER_NAME].otherListingIds,
    totalPageNewListing: state[REDUCER_NAME].totalPageNewListing,

    newListingData: state[REDUCER_NAME].newListingData,
    otherListingData: state[REDUCER_NAME].otherListingData,
    totalPageOtherListing: state[REDUCER_NAME].totalPageOtherListing,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadMoreCorporateDiv: params => dispatch(loadMoreCorporateDiv(params)),
    fetchListDataTable: params => dispatch(fetchListDataTable(params)),
    loadMoreListing: params => dispatch(loadMoreListing(params)),
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);
export default enhance(TableAnomaly);
